var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getIsShowReportWarningCloseAfterEdit
    ? _c(
        "div",
        {
          staticClass: "modal fade",
          class: [
            "modal fade",
            {
              show: _vm.getIsShowReportWarningCloseAfterEdit,
              "d-block": _vm.getIsShowReportWarningCloseAfterEdit,
            },
          ],
          staticStyle: { display: "block" },
          attrs: {
            "data-backdrop": "static",
            tabindex: "-1",
            "aria-hidden": "true",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog go-modal-confirm" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("i", { staticClass: "go-icon-48 go-icon-alert-warning" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "briefing.popup.warningCloseReportAfterEdit.firstText"
                          )
                        )
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "briefing.popup.warningCloseReportAfterEdit.secondText"
                        )
                      ) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("P", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "briefing.popup.warningCloseReportAfterEdit.thirdText"
                        )
                      )
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "briefing.popup.warningCloseReportAfterEdit.fourthText"
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.handleCancelCloseReportDetail },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "briefing.popup.warningCloseReportAfterEdit.cancel"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-primary",
                    attrs: {
                      id: "buttonCloseReportWarningCloseAfterEdit",
                      type: "button",
                      "data-dismiss": "modal",
                    },
                    on: { click: _vm.handleConfirmCloseReportDetail },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "briefing.popup.warningCloseReportAfterEdit.close"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }